import { Map }                from 'immutable';
import { Reducer }            from '../../Reducer';
import {
    simpleOnGetFail,
    simpleOnGetRequest,
    simpleOnGetSuccess,
    simpleOnItemCreateFail,
    simpleOnItemCreateRequest,
    simpleOnItemCreateSuccess,
    simpleOnItemLoadFail,
    simpleOnItemLoadRequest,
    simpleOnItemLoadSuccess,
    simpleOnItemUpdateFail,
    simpleOnItemUpdateRequest,
    simpleOnItemUpdateSuccess
}                             from '../../utils';
import { AUTH_LOGIN_SUCCESS } from '../Auth/types';
import * as TYPES             from './types';

const DEFAULT_STATE = Map({});

export default class UserReducer extends Reducer {
    NAME = 'User';

    alias = {
        [ AUTH_LOGIN_SUCCESS ]:      'onSuccess',
        [ TYPES.USERS_GET_REQUEST ]: 'onGetRequest',
        [ TYPES.USERS_GET_SUCCESS ]: 'onGetSuccess',
        [ TYPES.USERS_GET_FAIL ]:    'onGetFailure',

        [ TYPES.USER_CREATE_REQUEST ]: 'onItemCreateRequest',
        [ TYPES.USER_CREATE_SUCCESS ]: 'onItemCreateSuccess',
        [ TYPES.USER_CREATE_FAIL ]:    'onItemCreateFailure',

        [ TYPES.USER_LOAD_REQUEST ]: 'onItemLoadRequest',
        [ TYPES.USER_LOAD_SUCCESS ]: 'onItemLoadSuccess',
        [ TYPES.USER_LOAD_FAIL ]:    'onItemLoadFailure',

        [ TYPES.USER_UPDATE_REQUEST ]: 'onItemUpdateRequest',
        [ TYPES.USER_UPDATE_SUCCESS ]: 'onItemUpdateSuccess',
        [ TYPES.USER_UPDATE_FAIL ]:    'onItemUpdateFailure',
    };

    /**
     * on success method
     * @param state
     * @param action
     * @returns {Map<string, any>}
     */
    onSuccess ( state = DEFAULT_STATE, action = {} ) {
        const data = action.payload ? ( action.payload.data || action.payload ) : {};

        const { customer, user } = data;

        if ( user ) {
            state = state.merge(Map(user?.$all()))
                .set('_user', user);
        }

        if ( customer ) {
            state = state.set('_customer', customer);
        }

        return state;
    }

    /**
     *
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, Array|{}|boolean>}
     */
    onDefault ( state = DEFAULT_STATE ) {
        return state;
    }

    /**
     *
     * @param state
     * @param payload
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onGetRequest = simpleOnGetRequest(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onGetSuccess = simpleOnGetSuccess(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onGetFailure = simpleOnGetFail(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param payload
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemLoadRequest = simpleOnItemLoadRequest(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemLoadSuccess = simpleOnItemLoadSuccess(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemLoadFailure = simpleOnItemLoadFail(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param payload
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemCreateRequest = simpleOnItemCreateRequest(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemCreateSuccess = simpleOnItemCreateSuccess(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemCreateFailure = simpleOnItemCreateFail(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param payload
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemUpdateRequest = simpleOnItemUpdateRequest(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemUpdateSuccess = simpleOnItemUpdateSuccess(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemUpdateFailure = simpleOnItemUpdateFail(DEFAULT_STATE);
}
